import { FileObject } from './../../../core/interfaces/file-object';
import { ColleagueService } from './../../../core/services/colleague.service';
import { ProcedureCode } from './../../../core/services/app-data.service';
import { PatientNoteService } from './../../../core/services/patient-note.service';
import { PdfDownloadService } from './../../../core/services/pdf-download.service';
import { SpeechRecognitionService } from './../../../core/services/speech-recognition.service';
import { Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, catchError, combineLatest, debounceTime, delay, map, Observable, of, retryWhen, startWith, Subscription, switchMap, takeUntil, tap, throwError, timeout } from 'rxjs';
import { aiTokenGate } from '../../../core/utils/ai-token-gate';
import { BaseComponent } from './../../../core/components/base/base.component';
import { AiAssistantService } from './../../../core/services/ai-assistant.service';
import { FeedbackService } from './../../../core/services/feedback.service';
import { PatientService } from './../../../core/services/patient.service';
import { SocketService } from './../../../core/services/socket.service';
import { TokenUsageService } from './../../../core/services/token-usage.service';
import { UserService } from './../../../core/services/user.service';
import { GroupService } from './../../../core/services/group.service';
import { isStateModeGroup } from '../../util/state-mode.util';
import { PatientCommunicationService } from 'src/app/core/services/patient-communication.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { WhatsAppChatDialogComponent } from '../whatsapp-chat-dialog/whatsapp-chat-dialog.component';
import { NoteTypeService } from '../../../core/services/note-type.service';
import { FLOATING_DIALOG_LAYOUT_KEYS, FloatingDialogLayoutService } from '../../../core/services/floating-dialog-layout.service';
import { CURA_FORM_REVIEW_DEFAULT_SIZE, curaFormReviewDialogConfig } from '../../config/cura-form-review-dialog.config';
import { ClipboardService } from '../../../core/services/clipboard.service';
import { CuraAttachment, CuraAttachmentService } from '../../../core/services/cura-attachment.service';
import { CuraFillProgress, CuraFormFillService, CuraFormFill } from '../../../core/services/cura-form-fill.service';
import { CuraFormReviewDialogComponent } from '../cura-form-review-dialog/cura-form-review-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-ai-assistant-dialog',
  templateUrl: './ai-assistant-dialog.component.html',
  styleUrls: ['./ai-assistant-dialog.component.scss']
})
export class AiAssistantDialogComponent extends BaseComponent implements OnInit, OnDestroy {
  readonly floatingDialogLayoutKey = FLOATING_DIALOG_LAYOUT_KEYS.aiAssistant;

  @ViewChildren(MatMenuTrigger) menuTriggers!: QueryList<MatMenuTrigger>;
  todayDate: moment.Moment = moment();
  patient?: any;

  messages: {
    id: number; message: string; prompt?: string; createdAt: Date; isSent: boolean; sender: any;
    isLoading: boolean; isEditing?: boolean, isCopied?: boolean; suggestedTitle?: string;
    // What the server is busy with right now, shown instead of a bare spinner.
    status?: string;
    // A form fill lives in the conversation as a message of its own, so it scrolls with the
    // chat and survives being scrolled past. It used to be a separate card pinned above the
    // composer, which vanished the moment it was dismissed and took the download with it.
    formFill?: {
      fillId: string; fileName: string; status: string; progress: number;
      done: boolean; failed: boolean; message: string;
      counts?: { filled: number; blank: number; needsCheck: number; total: number };
      accepted?: boolean; promoted?: boolean; busy?: boolean;
    };
  }[] = [];
  newMessage: string = '';
  loading: boolean = false;
  private subscriptions: Subscription[] = [];
  private sendMessageTimeout: any;
  public dialogRef!: MatDialogRef<any>;
  selectedProcedureCodes: any[] = [];
  noteMediaObjects: FileObject[] = [];
  addingNote: any = {};
  @ViewChild('addNoteDialog') addNoteDialog?: TemplateRef<any>;
  filteredColleagues$!: Observable<any[]>;
  colleagues: any[] = [];
  private colleaguSsearchSubject = new BehaviorSubject<string>('');
  noteTypes: any[] = [];
  forCuraNoteTypes: any[] = [];
  selectedNoteTypeId: string | null = null;
  selectedNoteTypeLabel: string = '';
  messagePlaceholder: string = 'Type your message...';

  // ── Attachments (tasks/cura-form-filling.md Phase 1)
  attachments: CuraAttachment[] = [];
  uploadingAttachments = false;
  attachmentError: string | null = null;
  isDraggingOver = false;
  readonly attachmentAccept = CuraAttachmentService.ACCEPT;
  readonly maxAttachments = CuraAttachmentService.MAX_ACTIVE_PER_CONVERSATION;
  @ViewChild('attachmentInput') attachmentInput?: ElementRef<HTMLInputElement>;



  defaultActions = [
    {
      text: 'Quick Summary',
      message: 'Provide a brief summary of the patient\'s timeline',
      color: 'primary',
      prompt: 'Provide me with a summary of this patients timeline in two paragraphs, highlighting important information and findings. This will be used as a quick overview of previous events before the next consultation'
    },
    {
      text: 'Relevant Literature',
      message: 'Provide me with a list of relevant literature related to management of this patient\'s condition',
      color: 'primary',
      prompt: 'Provide me with a list of relevant literature related to management of this patient\'s condition'
    },
    {
      text: 'Treatment Insights',
      message: 'Provide me with a list of treatment insights for this patient',
      color: 'primary',
      prompt: 'Provide me with a list of 1 to 5 imminant medical problems this patient is facing and suggest potential treatment options for each of these'
    },
    {
      text: 'Clinical Scales',
      message: 'Provide me with a list of relevant clinical scales and their values for this patient',
      color: 'primary',
      prompt: 'Provide me with a list of 1 to 5 relevant clinical scales for this patient as well as a **VERY** brief description of each (2 lines). Calculate and include scoring for this patient if the required information is available. **Give preference to scales that are directly related to the patients diagnosis**'
    }
  ]

  socketId: string;

  userProfile: any;
  canSign: boolean = false;
  isPhysician: boolean = false;
  tokenBalance?: number;
  selectedDoctor: any = {};
  groupUsers: any[] = [];
  lockProcessing: boolean = false;
  /** The balance to warn about (100 or less), or null. */
  lowTokenBalance: number | null = null;
  isPremium: boolean = false;
  includeSignatureOnPdf: boolean = false;
  includeSignatureOnEmail: boolean = false;
  pdfDate: Date = new Date();
  hasSignaturePermission: boolean = false;

  sendingDetails = { patchPatient: false, search: '', name: '', email: '' };


  /** A state unit (tasks/state-mode.md) emails nothing from Cura. */
  get stateUnit(): boolean {
    return isStateModeGroup(this.groupService.group);
  }

  constructor(
    private chatService: AiAssistantService,
    private userService: UserService,
    private groupService: GroupService,
    private socketService: SocketService,
    private patientService: PatientService,
    private usageService: TokenUsageService,
    private communicationService: PatientCommunicationService,
    private pdfDownloadService: PdfDownloadService,
    private noteService: PatientNoteService,
    private colleagueService: ColleagueService,
    private noteTypeService: NoteTypeService,
    @Inject(MAT_DIALOG_DATA) public data: { patientId: string },
    private speechRecognitionService: SpeechRecognitionService,
    private clipboardService: ClipboardService,
    private curaAttachmentService: CuraAttachmentService,
    private curaFormFillService: CuraFormFillService,
    private floatingLayout: FloatingDialogLayoutService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
    this.socketId = this.generateRandomSocketId(25);

    //Getting current user signed
    this.userProfile = this.userService.user;
  }

  ngOnInit(): void {
    this.patientService.acquirePatientNavigationLock();
    this.socketService.emit('joinAIAssistant', { socketId: this.socketId });

    // A refresh or reconnect keeps the same conversation key, so anything already uploaded is
    // recovered rather than silently lost from the composer.
    this.reloadAttachments();
    this.reloadPreviousFills();

    // A fill runs on a worker that may be on another instance, so its progress arrives over the
    // room this dialog already joined rather than from the request that started it.
    this.subscriptions.push(
      this.socketService
        .listen(this.curaFormFillService.progressEvent(this.socketId), 'ai-assistant-dialog')
        .subscribe((update: CuraFillProgress) => this.onFormFillProgress(update))
    );

    this.patientService.currentPatient$
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        this.patient = result;
        this.sendingDetails = { patchPatient: false, search: '', name: '', email: '' };
      });

    // The token lock (core/utils/ai-token-gate.ts), worked out again whenever the practice OR its balance changes: the
    // balance moves while the dialog is open (tokenBalanceChanged), and a lock set only on a practice change went stale.
    combineLatest([this.groupService.selectedGroup$, this.usageService.tokenBalance$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([group, balance]: [any, any]) => {
        this.isPremium = group?.isPremium === true;
        const gate = aiTokenGate(this.isPremium, balance);
        this.lockProcessing = gate.locked;
        this.lowTokenBalance = gate.lowBalance;
        this.tokenBalance = typeof balance === 'number' ? balance : parseFloat(String(balance ?? ''));
      });

    // Subscribe to detected commands from speech recognition
    this.subscriptions.push(
      this.speechRecognitionService.getDetectedCommand().subscribe((commandData) => {
        this.handleVoiceCommand(commandData.command, commandData.payload);
      })
    );

    // Subscribe to Cura input text if Cura is open
    this.subscriptions.push(
      this.speechRecognitionService.getCuraInput().subscribe((curaText) => {
        // Handle Cura-specific input, like typing it into an input field
        console.log('Cura Text:', curaText);
        this.newMessage = curaText;

        // Clear the existing timeout if a new message is received
        if (this.sendMessageTimeout) {
          clearTimeout(this.sendMessageTimeout);
        }

        // Set a new timeout to send the message after 2 seconds of inactivity
        this.sendMessageTimeout = setTimeout(() => {
          this.sendMessage();
        }, 2000);

      })
    );


    this.colleagueService.colleagues$
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe(colleagues => {
        if (colleagues) {
          this.colleagues = colleagues;

        }
      })

    this.isPhysician = this.userService.isUserPhysician;
    this.canSign = this.userService.canUserSign;
    this.hasSignaturePermission = this.userService.isNonPhysician;
    this.groupUsers = this.userService.availableDoctorsList;

    this.filteredColleagues$ = this.colleaguSsearchSubject.pipe(
      startWith(''),
      debounceTime(300),
      switchMap(value => this.filterColleagues(value as string))
    );

    // Load forCura note types
    this.noteTypeService.noteTypes$
      .pipe(takeUntil(this.destroy$))
      .subscribe((noteTypes) => {
        if (noteTypes) {
          this.forCuraNoteTypes = noteTypes.filter((nt: any) => nt.forCura);
          // Update display if a note type was already selected
          if (this.selectedNoteTypeId) {
            this.updateNoteTypeDisplay();
          }
        }
      });

  }

  override ngOnDestroy(): void {
    this.patientService.releasePatientNavigationLock();
    super.ngOnDestroy();
    this.noteMediaObjects = [];
    this.selectedProcedureCodes = [];
    this.socketService.emit('leaveAIAssistant', { socketId: this.socketId });
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private handleVoiceCommand(command: string, payload?: any): void {
    switch (command) {
      case 'CLOSE_CURA':
        console.log('Closing cura...');
        this.dialog.closeAll();
        break;
      /* default:
        console.warn('Unknown command:', command); */
    }
  }

  private generateRandomSocketId(length: number): string {
    const timestamp = new Date().getTime().toString();
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length - timestamp.length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return (result + timestamp).toLowerCase().replace(/[^a-z0-9-]/g, '').substring(0, 63);;
  }


  /* sendMessage(message?: any): void {
    // An attachment on its own is a legitimate turn — "what does this say?" is implied.
    if (!this.newMessage.trim() && !message?.prompt && !this.attachments.length) return;
    this.loading = true;

    const newMessageObj = {
      id: this.messages.length + 1,
      message: message?.message || this.newMessage,
      prompt: message?.prompt || '',
      sender: 'user',
      createdAt: new Date(),
      isSent: true,
      isLoading: false
    };

    this.newMessage = '';
    this.messages.push(newMessageObj);

    const receivedMessageObj = {
      id: this.messages.length + 1,
      message: '',
      sender: 'assistant',
      createdAt: new Date(),
      isSent: false,
      isLoading: true
    };

    this.socketService.emit(`aiAssistant-send`, {
      channel: this.socketId,
      message: newMessageObj,
      responseId: receivedMessageObj.id,
      patientId: this.data.patientId,
      userId: this.userService.user.id,
      messages: this.messages || [],
      // Ids only — never file bytes over the socket (task 1.7).
      attachmentIds: this.attachments.map(a => a.id)
    });

    this.messages.push(receivedMessageObj);

    let outputStream = '';
    const responseSub = this.socketService.listen(`aiAssistant-${this.socketId}-message`, 'ai-assistant-dialog')
      .pipe(takeUntil(this.destroy$))
      .subscribe(output => {
        const message = this.messages.find(msg => msg.id === output.responseId);
        // A status update carries no text — it says what the turn is doing while it prepares.
        if (message && output.status) message.status = output.status;
        outputStream += output.results || '';
        message!.message = outputStream;
        this.scrollToBottom();
        if (output.completed) {
          responseSub.unsubscribe();
          outputStream = '';
          message!.isLoading = false;
          this.loading = false;
        }
      });
  } */

  // ───────────────────────────────────────────────────────────────────────────────
  //  Attachments — tasks/cura-form-filling.md Phase 1
  //
  //  Three ways in (picker, drag-drop, paste) all funnel through addFiles, so the limits and
  //  the error surface are identical however the file arrived.
  // ───────────────────────────────────────────────────────────────────────────────

  /** Forms CURA has filled for this patient before, so a review can be reopened (§17.10). */
  previousFills: CuraFormFill[] = [];

  reloadPreviousFills(): void {
    if (!this.data?.patientId) return;
    this.curaFormFillService.list(this.data.patientId, '')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (rows) => {
          this.previousFills = (rows || []).filter((f) => f.status === 'awaiting_review' || f.status === 'accepted');
        },
        error: () => { /* no list is the correct fallback here */ },
      });
  }

  reopenFill(fill: CuraFormFill): void {
    this.openFormReview({ fillId: fill.id, fileName: fill.fileName });
  }

  private reloadAttachments(): void {
    if (!this.data?.patientId) return;
    this.curaAttachmentService.list(this.data.patientId, this.socketId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (rows) => { this.attachments = rows || []; },
        error: () => { /* an empty composer is the correct fallback here */ }
      });
  }

  openAttachmentPicker(): void {
    this.attachmentInput?.nativeElement.click();
  }

  onAttachmentPicked(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.addFiles(Array.from(input.files || []));
    // Reset so picking the same file twice in a row still fires a change event.
    input.value = '';
  }

  onDragOver(event: DragEvent): void {
    if (!event.dataTransfer?.types?.includes('Files')) return;
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDraggingOver = false;
    this.addFiles(Array.from(event.dataTransfer?.files || []));
  }

  /**
   * Paste. Only acts when the clipboard actually carries files — otherwise pasting text into
   * the message box would be hijacked.
   */
  onPaste(event: ClipboardEvent): void {
    const files = Array.from(event.clipboardData?.items || [])
      .filter(i => i.kind === 'file')
      .map(i => i.getAsFile())
      .filter((f): f is File => !!f);
    if (!files.length) return;
    event.preventDefault();
    this.addFiles(files);
  }

  private addFiles(files: File[]): void {
    if (!files.length || this.uploadingAttachments) return;
    this.attachmentError = null;

    const problem = this.curaAttachmentService.validate(files, this.attachments.length);
    if (problem) { this.attachmentError = problem; return; }

    this.uploadingAttachments = true;
    this.curaAttachmentService.upload(this.data.patientId, this.socketId, files)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (rows) => {
          this.attachments = [...this.attachments, ...(rows || [])];
          this.uploadingAttachments = false;
        },
        error: (err) => {
          this.uploadingAttachments = false;
          // The server's message is the useful one — it knows why (bad magic bytes, a legacy
          // .doc, over the per-conversation cap) in a way the client cannot.
          this.attachmentError = err?.error?.error?.message || 'Could not attach that file.';
        }
      });
  }

  removeAttachment(attachment: CuraAttachment): void {
    this.attachmentError = null;
    const previous = this.attachments;
    this.attachments = this.attachments.filter(a => a.id !== attachment.id);
    this.curaAttachmentService.remove(attachment.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: (err) => {
          // Put it back: the file is still there, and a chip that vanished without the file
          // being removed would misrepresent what the assistant can see.
          this.attachments = previous;
          this.attachmentError = err?.error?.error?.message || 'Could not remove that attachment.';
        }
      });
  }

  attachmentIcon(attachment: CuraAttachment): string {
    return this.curaAttachmentService.iconFor(attachment.mediaType);
  }

  // ───────────────────────────────────────────────────────────────────────────────
  //  Form fills — tasks/cura-form-filling.md Phase 8
  // ───────────────────────────────────────────────────────────────────────────────

  /**
   * A running fill reports into the conversation as its own assistant message.
   *
   * The progress updates rewrite that one message rather than appending, so a three-minute fill
   * does not scroll the chat away from the doctor while they read.
   */
  private onFormFillProgress(update: CuraFillProgress): void {
    if (!update?.fillId) return;

    let msg = this.messages.find(m => m.formFill?.fillId === update.fillId);
    if (!msg) {
      msg = {
        id: this.messages.length + 1,
        message: '',
        sender: 'assistant',
        createdAt: new Date(),
        isSent: false,
        isLoading: false,
        formFill: {
          fillId: update.fillId, fileName: update.fileName || 'Your form',
          status: update.status, progress: update.progress || 0,
          done: false, failed: false, message: update.message,
        },
      };
      this.messages.push(msg);
    }

    const f = msg.formFill!;
    f.status = update.status;
    f.message = update.message;
    f.progress = update.progress ?? f.progress;
    f.done = !!update.completed && !update.failed;
    if (f.done) this.reloadPreviousFills();
    f.failed = !!update.failed;
    if (update.fileName) f.fileName = update.fileName;
    if (update.counts) f.counts = update.counts;
    // The handback prose IS the message body — rendered through the same pipe as any other
    // assistant reply, so it reads as part of the conversation.
    if (update.prose) msg.message = update.prose;
    else if (update.failed) msg.message = update.message;

    setTimeout(() => this.scrollToBottom(), 0);
  }

  /** task 8.5 — the review is where a fill is inspected; nothing bypasses it. */
  openFormReview(fill: any): void {
    const sizePos = this.floatingLayout.getMatDialogOpenOptions(
      FLOATING_DIALOG_LAYOUT_KEYS.curaFormReview, CURA_FORM_REVIEW_DEFAULT_SIZE);
    this.dialog.open(CuraFormReviewDialogComponent, curaFormReviewDialogConfig(fill.fillId, sizePos))
      .afterClosed().subscribe((updated) => {
      if (updated?.status === 'accepted') fill.accepted = true;
      if (updated?.promoted) fill.promoted = true;
    });
  }

  /** Download straight from the bubble. Refused server-side until the fill is accepted. */
  downloadFill(fill: any, variant: 'editable' | 'signed' = 'editable'): void {
    fill.busy = true;
    this.curaFormFillService.downloadUrl(fill.fillId, variant)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        // A new tab, not this one: the app guards leaving the page. The link carries a save-as
        // header, so the browser downloads it under its proper name and closes the tab.
        next: (d) => { fill.busy = false; window.open(d.url, '_blank'); },
        error: (err) => {
          fill.busy = false;
          // The likely refusal is REVIEW_REQUIRED, which is not an error but an instruction.
          this.attachmentError = err?.error?.error?.message
            || 'Review and accept the form before downloading it.';
        },
      });
  }

  addFillToTimeline(fill: any): void {
    if (fill.promoted || fill.busy) return;
    fill.busy = true;
    this.curaFormFillService.promote(fill.fillId, { title: `Completed form — ${fill.fileName}` })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => { fill.busy = false; fill.promoted = true; },
        error: (err) => {
          fill.busy = false;
          this.attachmentError = err?.error?.error?.message
            || 'Could not add that form to the timeline.';
        },
      });
  }


  sendMessage(message?: any): void {
    // Locked for tokens: nothing is sent (the controls are hidden too, but a keyboard shortcut or a voice command still calls this).
    if (this.lockProcessing) return;
    // If a note type is selected, generate prompt from note type
    if (this.selectedNoteTypeId && !message?.prompt) {
      const selectedNoteType = this.forCuraNoteTypes.find(nt => nt.id === this.selectedNoteTypeId);
      if (selectedNoteType) {
        message = { 
          message: this.newMessage.trim() || 'Generate content using the selected note type template.',
          prompt: this.generateCuraPromptFromNoteType(selectedNoteType, this.newMessage.trim())
        };
        this.selectedNoteTypeId = null; // Reset selection after use
        this.updateNoteTypeDisplay(); // Update display properties
      }
    }
    
    if (!this.newMessage.trim() && !message?.prompt) return;
    this.loading = true;

    const maxAttempts = 3;
    let attempt = 0;
    let outputStream = '';

    // Prepare the message objects
    const newMessageObj = {
      id: this.messages.length + 1,
      message: message?.message || this.newMessage,
      prompt: message?.prompt || '',
      sender: 'user',
      createdAt: new Date(),
      isSent: true,
      isLoading: false
    };

    // Clear the input and add the user's message only on the first attempt.
    this.newMessage = '';
    if (attempt === 0) {
      this.messages.push(newMessageObj);
    }

    const receivedMessageObj = {
      id: this.messages.length + 1,
      message: '',
      sender: 'assistant',
      createdAt: new Date(),
      isSent: false,
      isLoading: true,
      // Say what is happening from the very first frame. The server sends its own stages from
      // here on and overwrites this within a second — but without it the bubble opens on a
      // generic label, which is the one moment the user is most certainly looking at it.
      status: this.attachments.length
        ? (this.attachments.length === 1
          ? `Reading ${this.attachments[0].fileName}…`
          : `Reading your ${this.attachments.length} files…`)
        : 'Reading this patient\'s file…',
    };

    // Add the assistant message placeholder only on the first attempt.
    if (attempt === 0) {
      this.messages.push(receivedMessageObj);
    }

    // Create an observable that sends the message and listens for the response.
    const sendAndListen$ = new Observable<any>(observer => {
      // (Re)send the socket message for each attempt.
      this.socketService.emit(`aiAssistant-send`, {
        channel: this.socketId,
        message: newMessageObj,
        responseId: receivedMessageObj.id,
        patientId: this.data.patientId,
        userId: this.userService.user.id,
        messages: this.messages || [],
        // Ids only — never file bytes over the socket (task 1.7).
        attachmentIds: this.attachments.map(a => a.id)
      });
      console.log(`Message sent (attempt ${attempt + 1})`);

      // Listen for responses from the server.
      const sub = this.socketService.listen(`aiAssistant-${this.socketId}-message`, 'ai-assistant-dialog')
        .subscribe({
          next: (output) => {
            const m = this.messages.find(msg => msg.id === receivedMessageObj.id);
            if (m && output.status) m.status = output.status;
            outputStream += output.results || '';
            observer.next({ output, outputStream });
            // When the server signals completion, finish the observable.
            if (output.completed) {
              observer.complete();
            }
          },
          error: (err) => observer.error(err)
        });

      return () => sub.unsubscribe();
    });

    sendAndListen$
      .pipe(
        // Wait for a response within 10 seconds; if nothing comes through, error.
        timeout(10000),
        // If a timeout or error occurs, wait 1 second, re-send, and retry (up to maxAttempts).
        retryWhen(errors =>
          errors.pipe(
            tap(err => {
              attempt++;
              // Clear the partial response so new data starts fresh.
              outputStream = '';
              // Update the UI message to let the user know a retry is occurring.
              const msg = this.messages.find(m => m.id === receivedMessageObj.id);
              if (msg) {
                msg.message = `Retrying... (attempt ${attempt} of ${maxAttempts})`;
              }
              if (attempt < maxAttempts) {
                // Rejoin the assistant channel before retrying
                this.socketService.emit('joinAIAssistant', { socketId: this.socketId });
                console.warn(`No response received, retrying (attempt ${attempt + 1})...`);
              } else {
                console.error('Max retry attempts reached.');
                throw err;
              }
            }),
            delay(1000)
          )
        ),
        takeUntil(this.destroy$),
        // In case retries are exhausted, handle the error.
        catchError(err => {
          return throwError(err);
        })
      )
      .subscribe({
        next: (data) => {
          // Update the assistant's message as new output comes in.
          const msg = this.messages.find(m => m.id === receivedMessageObj.id);
          if (msg) {
            // If the current message indicates a retry, clear the accumulated output.
            if (msg.message && msg.message.startsWith('Retrying')) {
              outputStream = '';
            }
            // Use the accumulated stream from the observer only (it already adds each chunk there).
            // Do not add again here to avoid double-appending every chunk.
            const accumulated = data.outputStream ?? outputStream;
            msg.message = accumulated;

            // The stage line is cleared by the FIRST REAL TEXT, not by every emission.
            //
            // This used to be an unconditional `msg.status = undefined` above, which ran on the
            // status-only heartbeats too — the observer set the stage one line earlier and this
            // wiped it immediately, so no stage ever survived long enough to be seen and the
            // bubble sat on its generic fallback for the whole turn.
            if (accumulated) msg.status = undefined;
            if (data.output?.suggestedTitle) {
              msg.suggestedTitle = data.output.suggestedTitle;
            }
          }
          this.scrollToBottom();
        },
        error: (err) => {
          // After max attempts, display an error in the assistant's message.
          const msg = this.messages.find(m => m.id === receivedMessageObj.id);
          if (msg) {
            msg.message = 'Error: Response timed out. Please try again later.';
            msg.isLoading = false;
          }
          this.loading = false;
        },
        complete: () => {
          // On successful completion, mark the assistant's message as finished.
          const msg = this.messages.find(m => m.id === receivedMessageObj.id);
          if (msg) {
            msg.isLoading = false;
          }
          this.loading = false;
        }
      });

  }

  copyMessage(message: any): void {
    this.clipboardService.copyMarkdown(message.message).then(ok => {
      if (ok) {
        message.isCopied = true;
        setTimeout(() => { message.isCopied = false; }, 5000);
      }
    });
  }

  toggleEditing(message: any): void {
    message.isEditing = !message.isEditing;
  }

  async addMessageToTimeline(message: any): Promise<void> {
    const content = message.message;
    const suggestedTitle = message.suggestedTitle ?? '';

    const dialogResult = await this.openAddNoteDialog(content, suggestedTitle);

    if (!dialogResult) return;

    const { date, noteTypeId, title, notes, isProcedure, isBilling, procedureCodes } = dialogResult;

    if (!date || !title) {
      this.showToastMessage('Date and Procedure/Title are required to add a note');
      return
    };

    const patient = this.patientService.patient;
    const newMediaFiles = this.noteMediaObjects.filter(obj => !obj.id);


    let noteData = {
      date: date.utc().startOf('day').toISOString(),
      groupId: patient.groupId,
      patientId: patient.id,
      noteType: noteTypeId,
      noteTypeHeadings: '',
      isProcedure: isProcedure,
      isBilling: isBilling || false,
      procedureCodes: procedureCodes || [],
      title: title,
      notes: notes,
      existingMedia: []
    };

    message.message = notes;

    const formData = new FormData();
    formData.append('data', JSON.stringify(noteData));

    const mediaAppendPromises = newMediaFiles.map((obj, index) => {
      return fetch(obj.url)
        .then(response => response.blob())
        .then(blob => {
          formData.append(`newMedia${index}`, blob, `${moment().unix()}.${obj.type.split('/')[1]}`);
        });
    });

    Promise.all(mediaAppendPromises)
      .then(() => {
        this.noteService.addNote(formData)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (result) => {
              this.showToastMessage('Patient note saved successfully');
            },
            error: (error) => {
              console.error('Error saving patient note: ', error);
              this.showToastMessage('There was an error saving the patient note. Please try again.');
            }
          });
      });
  }

  onNoteMediaUpload(files: FileObject[]) {

    const newMediaObjects = files.map(file => ({
      ...file,
      //url: URL.createObjectURL(file),
      type: file.type,
    }));

    // Check for duplicates and avoid appending unnecessarily
    const uniqueMediaObjects = newMediaObjects.filter(newObj =>
      !this.noteMediaObjects.some(existingObj => existingObj.url === newObj.url)
    );

    this.noteMediaObjects = [...this.noteMediaObjects, ...uniqueMediaObjects];
  }

  onFilesEdited(files: any) {
    this.noteMediaObjects = files as FileObject[];
  }

  onNoteMediaDelete(fileObject: FileObject) {
    const index = this.noteMediaObjects.findIndex(obj => obj.url === fileObject.url);
    if (index > -1) {
      this.noteMediaObjects.splice(index, 1);
    }
  }

  onSelectedProcedureCodesChanged(codes: ProcedureCode[], addingNote: any) {
    if (addingNote) {
      addingNote.procedureCodes = codes;
    } else {
      this.selectedProcedureCodes = codes;
    }
  }

  toggleCodeStatus(note: any, type: string) {
    switch (type) {
      case 'up-front':
        if (note.paidCash) {
          note.noCharge = false;
          note.procedureCodes = note.procedureCodes.map((c: any) => { return { ...c, noCharge: false, paidCash: true } });
        }
        break;
      case 'no-charge':
        if (note.noCharge) {
          note.paidCash = false;
          note.procedureCodes = note.procedureCodes.map((c: any) => { return { ...c, noCharge: true, paidCash: false } });
        }
        break;
    }
  }

  openAddNoteDialog(content: any, suggestedTitle: string = '') {
    let procedureCodes = this.selectedProcedureCodes;
    this.addingNote = { date: moment(), noteTypeId: null, title: suggestedTitle, isProcedure: false, isBilling: false, notes: content, procedureCodes: procedureCodes, paidCash: false, noCharge: false };
    this.dialogRef = this.dialog.open(this.addNoteDialog!/* , { disableClose: true } */);
    return this.dialogRef.afterClosed().toPromise();
  }

  patchPatientEmailDetails() {
    if (this.sendingDetails.patchPatient) {
      this.sendingDetails.name = `${this.patient.name} ${this.patient.surname}`;
      this.sendingDetails.email = this.patient.email;
    } else {
      this.sendingDetails.name = '';
      this.sendingDetails.email = '';
    }
  }

  onSearchChange(searchValue: string) {
    this.colleaguSsearchSubject.next(searchValue);
  }

  private filterColleagues(value: string): Observable<any[]> {
    if (!value || typeof value !== 'string') return of([]);
    const filterValue = value.toLowerCase();
    return of(this.colleagues)
      .pipe(
        map(colleagues => colleagues.map(colleague => {
          colleague.fullName = `${colleague.title} ${colleague.name} ${colleague.surname}`;
          return colleague;
        }).filter(colleague =>
          colleague.fullName.toLowerCase().includes(filterValue) ||
          colleague.email.toLowerCase().includes(filterValue)
        ))
      );
  }

  selectColleague(colleague: any) {
    this.sendingDetails = { patchPatient: false, search: '', name: `${colleague.title} ${colleague.name} ${colleague.surname}`, email: colleague.email };
    this.colleaguSsearchSubject.next('');
  }

  onRecipientSelected(recipient: {name: string, email: string}) {
    this.sendingDetails.name = recipient.name;
    this.sendingDetails.email = recipient.email;
  }

  //Adjust both function and the in call functions by adding an optional parameter(signatureImageURL)

  emailMessage(message: any): void {
    if (!this.sendingDetails.email) {
      this.showToastMessage('An email address was not provided. Please check the relevant email field try again.');
      return;
    }

    if (this.includeSignatureOnPdf && this.isPhysician) {
      const appendSignatureMessage = message.message;
      this.emailCommunication(this.patientService.patient.id, 'Note', this.sendingDetails.name, this.sendingDetails.email, appendSignatureMessage, '', [], true, this.userProfile.signatureImageUrl, `${this.userProfile.title} ${this.userProfile.name} ${this.userProfile.surname}`, this.pdfDate)

    } else if (!this.isPhysician && this.hasSignaturePermission && this.includeSignatureOnPdf) {
      const appendSignatureMessage = message.message;
      this.emailCommunication(this.patientService.patient.id, 'Note', this.sendingDetails.name, this.sendingDetails.email, appendSignatureMessage, '', [], true, this.selectedDoctor.signatureImageUrl, `${this.selectedDoctor.title} ${this.selectedDoctor.name} ${this.selectedDoctor.surname}`, this.pdfDate)

    } else if (!this.includeSignatureOnPdf) {
      this.emailCommunication(this.patientService.patient.id, 'Note', this.sendingDetails.name, this.sendingDetails.email, message.message, '', [], undefined, undefined, undefined, this.pdfDate)
    }
  }

  downloadAsPdf(event: MouseEvent, message: any) {
    event.preventDefault();
    event.stopPropagation();
    const patient = this.patientService.patient;
    const filename = `MedicAI_${patient.name} ${patient.surname}_Note_${moment().valueOf()}`;

    if (this.includeSignatureOnPdf && this.isPhysician) {

      const appendSignatureMessage = message.message;
      this.pdfDownloadService.downloadPdf({
        content: appendSignatureMessage,
        filename: filename,
        patient: patient,
        images: [],
        attachSignature: this.includeSignatureOnPdf,
        signatureUrl: this.userProfile.signatureImageUrl,
        signatoryName: `${this.userProfile.title} ${this.userProfile.name} ${this.userProfile.surname}`,
        date: this.pdfDate,
      });

    } else if (!this.isPhysician && this.hasSignaturePermission && this.includeSignatureOnPdf) {
      const appendSignatureMessage = message.message;
      this.pdfDownloadService.downloadPdf({
        content: appendSignatureMessage,
        filename: filename,
        patient: patient,
        images: [],
        attachSignature: this.includeSignatureOnPdf,
        signatureUrl: this.selectedDoctor.signatureImageUrl,
        signatoryName: `${this.selectedDoctor.title} ${this.selectedDoctor.name} ${this.selectedDoctor.surname}`,
        date: this.pdfDate,
      });

    } else if (!this.includeSignatureOnPdf || !this.canSign) {
      this.pdfDownloadService.downloadPdf({
        content: message.message,
        filename: filename,
        patient: patient,
        images: [],
        attachSignature: false,
        date: this.pdfDate,
      });

    }

    this.closeAllMenus(this.menuTriggers);
  }

  handleMenuKeydown(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      event.stopPropagation();
    }
  }

  scrollToBottom(): void {
    const messagesContainer = document.querySelector('.cura-messages');
    if (messagesContainer) {
      setTimeout(() => {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }, 100);
    }
  }

  emailCommunication(userId: string, note = 'Note', name: string, email: string, content: any, param = '', arr: any, attachSignature?: boolean, signatureUrl?: string, signatoryName?: string, pdfDate?: Date | string): void {
    const plainTextContent = this.pdfDownloadService.convertToPlainText(content);
    this.communicationService.sendAIContentEmail({
      patientId: userId,
      type: note,
      name: name,
      email: email,
      content: plainTextContent,
      speciality: param,
      images: arr,
      attachSignature: attachSignature,
      signatureUrl: signatureUrl,
      signatoryName: signatoryName,
      pdfDate: pdfDate,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          this.showToastMessage('Email sent successfully');
          this.closeAllMenus(this.menuTriggers);
        },
        error: (error) => {
          console.error('Error sending AI email: ', error);
          this.showToastMessage('There was an error sending the email. Please try again.');
        }
      });
  }

  openWhatsAppDialog(message?: any): void {
    const plainTextContent = message ? this.pdfDownloadService.convertToPlainText(message.message) : '';
    const dialogRef = this.dialog.open(WhatsAppChatDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      height: '80vh',
      maxHeight: '90vh',
      data: {
        patientId: this.data.patientId,
        patient: this.patient,
        initialMessage: plainTextContent
      }
    });
  }

  /**
   * Convert message to plain text for WhatsApp dialog
   * Used by the WhatsApp dialog trigger directive
   */
  getMessagePlainText(message?: any): string {
    if (!message) {
      return '';
    }
    return this.pdfDownloadService.convertToPlainText(message.message);
  }

  generateCuraPromptFromNoteType(noteType: any, userMessage?: string): string {
    let prompt = `Generate a ${noteType.label} using the following structure:\n\n`;
    
    // Add headings and subheadings
    if (noteType.headings && noteType.headings.length > 0) {
      prompt += 'STRUCTURE:\n';
      noteType.headings.forEach((heading: any) => {
        prompt += `- ${heading.text}\n`;
        if (heading.subheadings && heading.subheadings.length > 0) {
          heading.subheadings.forEach((subheading: any) => {
            prompt += `  - ${subheading.text}\n`;
          });
        }
      });
      prompt += '\n';
    }
    
    // Add user instructions if available
    if (noteType.userPrompt) {
      prompt += `INSTRUCTIONS:\n${noteType.userPrompt}\n\n`;
    }
    
    // Add user message if provided
    if (userMessage) {
      prompt += `USER REQUEST:\n${userMessage}\n\n`;
    }
    
    prompt += 'Please generate the content following the structure above, using the headings and subheadings as a guide.';
    
    return prompt;
  }

  onNoteTypeSelected(noteTypeId: string | null): void {
    this.selectedNoteTypeId = noteTypeId;
    this.updateNoteTypeDisplay();
  }

  clearNoteTypeSelection(): void {
    this.selectedNoteTypeId = null;
    this.updateNoteTypeDisplay();
  }

  private updateNoteTypeDisplay(): void {
    if (this.selectedNoteTypeId) {
      const selectedNoteType = this.forCuraNoteTypes.find(nt => nt.id === this.selectedNoteTypeId);
      if (selectedNoteType) {
        this.selectedNoteTypeLabel = selectedNoteType.label;
        this.messagePlaceholder = `Add additional details about this ${selectedNoteType.label} request (optional)...`;
      } else {
        this.selectedNoteTypeLabel = '';
        this.messagePlaceholder = 'Type your message...';
      }
    } else {
      this.selectedNoteTypeLabel = '';
      this.messagePlaceholder = 'Type your message...';
    }
  }
}